import { Companies } from '@factorin/domain';

import { withUrl, get } from '../rest';


const companiesPart = withUrl('companies');
export const companies = {
    // co
    item: get<void, Companies.DetailCompany>(
        () => companiesPart({
            path: 'self',
        }),
    ),
    clientprofiles: get<void, Companies.ClientProfileTypes>(
        () => companiesPart({
            path: 'self/clientprofiles',
        }),
    ),
};
